import React from "react";
import DocumentsPage from "@/pages/shared/DocumentsPage";

/**
 * Content Writers dashboard now uses the unified Doc Builder, but scoped to
 * `kind=blog` documents. Existing blog rows are auto-migrated to the
 * documents collection on first load (server-side, idempotent per user).
 *
 * Result: tables, images, share link, page-break preview, margin presets,
 * font size shortcuts, PDF + DOCX export — everything from the Doc Builder
 * is now available to Content Writers with zero feature drift.
 */
export default function CWDashboard() {
  return (
    <DocumentsPage
      kind="blog"
      pageTitle="Blogs"
      pageSubtitle="Link your Google Docs drafts here so the team can preview and access them from the dashboard."
    />
  );
}
